module.exports = __webpack_public_path__ + "static/media/Roboto-Light.d26871e8.woff2";